module.exports = __webpack_public_path__ + "img/login.66466919.jpg";